import React, { useState } from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../../../../constants'
import { getAllocationByBillingType } from '../../../../../../function/billing'
import { percentage } from '../../../../../../function/math'

export const ListDetail = ({ data, revenueAllocation }) => {
  const [showDetails, setShowDetails] = useState(false)
  const billing_types = data ? data.billing_types : []

  const handleShowDetails = () => setShowDetails(!showDetails)

  return (
    <ListWrapper>
      <HeaderText>Lists Details</HeaderText>
      {showDetails && billing_types.map((d, key) => {
        const selectAllocation = getAllocationByBillingType(revenueAllocation, d)
        const billingPrice = d.price

        return (
          <ListRow key={ key }>
            <FlexCol flex={ 3 }>
              <FlexRow>
                <FlexCol flex={ 1 }>
                  <Title>Type</Title>
                  <Text>{ d.label }</Text>
                </FlexCol>
                <FlexCol flex={ 1 } margin='0 12px'>
                  <Title>Value</Title>
                  <Number>{`฿ ${billingPrice}`}</Number>
                </FlexCol>
              </FlexRow>
            </FlexCol>
            <AllocateCol>
              <Title>LOB Allocate</Title>
              <FlexCol>
                {selectAllocation && selectAllocation.lobs.map((t, i) => (
                  <DetailRow key={ i }>
                    <AllocationTextWrapper>
                      <AllocateText>{`${t._lob_name}: ${t.lob_percent}%`}</AllocateText>
                    </AllocationTextWrapper>
                    <AllocationTextWrapper>
                      <AllocateText>{billingPrice ? `฿${percentage(billingPrice, t.lob_percent)}` : '-'}</AllocateText>
                    </AllocationTextWrapper>
                  </DetailRow>
                ))}
              </FlexCol>
            </AllocateCol>
          </ListRow>
        )
      })}
      <AddWrapper onClick={ handleShowDetails }>
        <AddText>{ showDetails ? '- Hide' : '+ See details' }</AddText>
      </AddWrapper>
    </ListWrapper>
  )
}

const Row = styled.div`
  display: flex;
`

const FlexRow = styled(Row)`
  margin-bottom: 16px;
  ${p => p.flex && `flex: ${p.flex}`}
`

const DetailRow = styled(Row)`
  margin: 8px 0;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
`

const FlexCol = styled(Col)`
  margin: ${p => p.margin};
  ${p => p.flex && `flex: ${p.flex}`}
`

const AllocateCol = styled(FlexCol)`
  width: 300px;
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ListRow = styled.div`
  height: 100%;
  display: flex;
  background: #F9F9F9;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const Number = styled.span`
  font-family: ${FONTS.NOTOSANS};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const AllocateText = styled(Number)`
  font-size: ${FONTS.SMALL_SIZE};
`

const AllocationTextWrapper = styled.div`
  min-width: 150px;
`

const AddWrapper = styled.div`
  display: flex;
  height: 30px;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
`

const AddText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.TITLE_SIZE};
  color: #2D9CDB;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ar-billing/edit-billing/list-detail/index.js